import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

const TONES = {
  slate: "bg-slate-100 text-slate-700", emerald: "bg-emerald-50 text-emerald-700", sky: "bg-sky-50 text-sky-700", red: "bg-red-50 text-red-700",
  amber: "bg-amber-50 text-amber-700", violet: "bg-violet-50 text-violet-700",
};
export function Pill({ children, tone = "slate", testid }) {
  return <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ${TONES[tone] || TONES.slate}`} data-testid={testid}>{children}</span>;
}

export function Field({ label, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-0.5 sm:gap-3 py-1.5">
      <dt className="text-xs sm:text-sm text-slate-500 sm:w-44 shrink-0">{label}</dt>
      <dd className="text-sm text-slate-900 min-w-0 break-words">{children}</dd>
    </div>
  );
}

export function LoadingBlock({ rows = 3 }) {
  return <div className="space-y-2" data-testid="admin-loading">{Array.from({ length: rows }, (_, i) => <Skeleton key={i} className="h-12 w-full" />)}</div>;
}

export function ErrorCard({ message, onRetry, testid = "admin-error" }) {
  return (
    <Card className="p-6 text-center space-y-3" data-testid={testid} role="alert">
      <AlertTriangle className="mx-auto text-amber-500" size={20} aria-hidden="true" />
      <p className="text-sm text-slate-700">{message}</p>
      {onRetry && <Button variant="outline" onClick={onRetry}><RefreshCw size={14} className="mr-1.5" />Réessayer</Button>}
    </Card>
  );
}

export function EmptyCard({ icon: Icon, title, hint, testid = "admin-empty", children }) {
  return (
    <Card className="p-8 text-center space-y-2" data-testid={testid}>
      {Icon && <Icon className="mx-auto text-slate-300" size={26} aria-hidden="true" />}
      <h3 className="font-medium text-slate-900">{title}</h3>
      {hint && <p className="text-sm text-slate-500 max-w-md mx-auto">{hint}</p>}
      {children}
    </Card>
  );
}

export function PageHeader({ title, description, actions }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="font-display font-bold text-2xl text-slate-900">{title}</h1>
        {description && <p className="text-sm text-slate-500">{description}</p>}
      </div>
      {actions}
    </div>
  );
}
